import { render, staticRenderFns } from "./DetailsCertificateForm.vue?vue&type=template&id=30057b33&"
import script from "./DetailsCertificateForm.vue?vue&type=script&lang=ts&"
export * from "./DetailsCertificateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports